import { bool, element, number, object, oneOfType, shape, string, url } from "prop-types";

export const creatorShape = {
  fname: string,
  lname: string,
  isInactive: bool,
  id: number,
  profilePictureUrl: url,
};

export const noteShape = {
  id: number,
  creator: shape(creatorShape),
  private: bool,
  body: oneOfType([string, element]),
  createdAt: string,
  size: number,
  title: string,
  url: string,
  viewingDate: string,
  viewingTime: string,
};

export const viewingShape = {
  id: number,
  creator: shape(creatorShape),
  private: bool,
  body: oneOfType([string, element]),
  createdAt: string,
  date: string,
  time: string,
};

export const callShape = {
  id: number,
  creator: shape(creatorShape),
  contact: shape({
    fname: string,
    lname: string,
    id: number,
    profilePictureUrl: url,
  }),
  private: bool,
  body: oneOfType([string, element]),
  createdAt: string,
  date: string,
  time: string,
};

export const emailShape = {
  id: number,
  creator: shape(creatorShape),
  contact: shape({
    fname: string,
    lname: string,
    id: number,
    profilePictureUrl: url,
  }),
  private: bool,
  body: oneOfType([string, element]),
  createdAt: string,
  date: string,
  time: string,
};

export const systemEventShape = {
  body: string,
  creator: shape(creatorShape),
  meta: object,
  createdAt: string,
};
